import { makeStyles } from '@material-ui/core/styles';

const styleFilter = makeStyles((theme) => ({
  selectStatus: {
    width: '100%',
    border: '1px solid #ccc',
    padding: '7px 6px',
    marginTop: '10px',
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    paddingRight: '10px',
    margin: '0 0 0 auto',
  },
  headFilter: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  buttonClose: {
    background: 'none',
    border: 'none',
    outline: 'none',
    cursor: 'pointer',
  },
  filtersBox: {
    position: 'absolute',
    marginTop: '172px',
    background: '#185b86',
    width: '315px',
    color: '#fff',
    padding: '10px',
    zIndex: '99',
    right: '0',
    marginRight: '9px',
    borderRadius: '5px',
  },
  labelFilter: {
    fontSize: '14px',
    fontWeight: 'bold',
  },
  buttonFilter: {
    background: '#026894',
    border: 'none',
    color: '#fff',
    width: '100%',
    padding: '8px 0',
    marginTop: '9px',
    borderRadius: '2px',
    fontWeight: 'bold',
    cursor: 'pointer',
  },
  button: {
    cursor: 'pointer',
    width: '110px',
    backgroundColor: '#d5d5d5',
    color: '#000',
    height: '32px',
    boxShadow: 'none',
    border: 'none',
    borderRadius: '4px',
    textTransform: 'capitalize',
    fontSize: '14px',
    marginRight: '16px',
    transition: 'all ease 0.3s',
    '&:hover': {
      backgroundColor: '#aaa',
    },
  },
}));

export default styleFilter;
